/**
 * Слайдеры раздела блога: лента записей, рубрики, популярное, дипломы автора.
 *
 * Перенесено из инлайн-блоков `<script>` трёх шаблонов (Этап 6 §0,
 * 👤 указание владельца «все инлайн скрипты переносить в файлы»):
 *   home.php            → `.swiper-main`, `.swiper-category`
 *   category.php        → `.swiper-main`, `.swiper-popular`
 *   single-authors.php  → `.author__diplomas`, `.swiper-popular`
 *
 * 🔴 Зачем это понадобилось, а не «работало же»: инлайн-вызовы ждали
 * ГЛОБАЛЬНЫЙ `Swiper` из `assets/js/swiper-bundle.min.js`. Пока они
 * существовали, вендорную библиотеку нельзя было снять ни с одного
 * из трёх блоков `wp_enqueue` — 130 КБ статики ради того, что в бандле
 * уже есть. В модуле Swiper приходит `import`-ом и в `window` не попадает.
 *
 * ⚠️ `.swiper-main` на `home` и `category` настроен ОДИНАКОВО, но это
 * два разных блока разметки. Объединены сознательно: опции совпадали
 * до последнего ключа, расхождение означало бы копипасту двух файлов.
 *
 * ⚠️ `.swiper-popular` живёт на `category` и `single-authors`, его
 * опции совпадают с `.swiper-category` — отсюда общая конфигурация
 * `FREE_SCROLL` на три селектора.
 */

/** Лента записей: один слайд, автопрокрутка, точки и стрелки. */
const MAIN = {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        enabled: true,
        nextEl: '.swiper-main-button-next',
        prevEl: '.swiper-main-button-prev',
    },
    autoplay: {
        delay: 3500,
        disableOnInteraction: true,
    },
};

/**
 * Горизонтальная лента с инерцией: рубрики и «популярное».
 *
 * `slidesPerView: 'auto'` — ширину задаёт CSS, слайды разной длины.
 */
const FREE_SCROLL = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    freeMode: true,
};

/**
 * Дипломы автора: 2 слайда от 991px, 1 ниже.
 *
 * ⚠️ `shortSwipes: false` — короткий свайп НЕ листает. Опция была
 * в инлайне, перенесена как есть: на вертикальных сертификатах
 * случайное касание пролистывало блок.
 *
 * Элементы навигации ищутся внутри `.author__diplomas-wrap`: на той же
 * странице есть второй слайдер (`.swiper-popular`), и глобальные
 * `.swiper-button-next` поймали бы чужие кнопки.
 */
const DIPLOMAS = {
    shortSwipes: false,
    breakpoints: {
        991: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        0: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
    },
    navigation: {
        nextEl: '.author__diplomas-wrap .swiper-button-next',
        prevEl: '.author__diplomas-wrap .swiper-button-prev',
    },
    pagination: {
        el: '.author__diplomas-wrap .swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
};

/** Селектор → опции. Инициализируется только то, что есть в разметке. */
const SLIDERS = [
    ['.swiper-main', MAIN],
    ['.swiper-category', FREE_SCROLL],
    ['.swiper-popular', FREE_SCROLL],
    ['.author__diplomas', DIPLOMAS],
];

export default async function BlogSliders() {
    const present = SLIDERS.filter(([selector]) => document.querySelector(selector));

    // Проверка обязательна: без неё Swiper (181 КБ) качался бы на всех
    // страницах темы. `new Swiper()` по отсутствующему селектору молча
    // создаёт пустой инстанс и об ошибке не сообщает
    if (!present.length) return;

    const [{ default: Swiper }, { Navigation, Pagination, Autoplay, FreeMode }] = await Promise.all([
        import('swiper'),
        import('swiper/modules'),
    ]);

    // 🔴 Модули перечисляются явно. В вендорном `swiper-bundle.min.js`
    // они были встроены, поэтому инлайн-вызовы обходились без `modules`.
    // В npm-сборке отсутствие модуля НЕ даёт ошибки: слайдер соберётся,
    // но стрелки, точки и автопрокрутка просто не появятся
    //
    // ⚠️ Соответствие через `Map`, а не объект: ключи здесь — объекты
    // опций, а в обычном объекте они привелись бы к строке
    // `"[object Object]"`, и все три конфигурации слились бы в одну
    const modules = new Map([
        [MAIN, [Navigation, Pagination, Autoplay]],
        [FREE_SCROLL, [FreeMode]],
        [DIPLOMAS, [Navigation, Pagination]],
    ]);

    for (const [selector, options] of present) {
        new Swiper(selector, { ...options, modules: modules.get(options) });
    }
}
